// Hero slideshow: fade loop (1->2->3->...->1) without Dawn auto-rotate
(function () {
    'use strict';
  
    function initHeroFade() {
      // Hero section detection: first section in MainContent (あなたの現状に合わせる)
      const heroSection =
        document.querySelector('section[id*="hero"]:first-of-type') ||
        document.querySelector('#MainContent > section:first-of-type');
  
      if (!heroSection) return;
  
      const heroSlideshow = heroSection.querySelector('slideshow-component');
      if (!heroSlideshow) return;
  
      const slider = heroSlideshow.querySelector('[id^="Slider-"]');
      if (!slider) return;
  
      // Slides
      const slides = Array.from(slider.querySelectorAll('.slideshow__slide'));
      if (slides.length <= 1) return;
  
      // Enable fade mode CSS
      slider.classList.add('is-fade');
  
      // Ensure slider has height: keep current height; if it collapses, set min-height by JS
      // (通常は banner の高さがあるので不要)
      // slider.style.minHeight = slider.offsetHeight + 'px';
  
      // Prevent Dawn slider behavior interfering (scroll snap etc.)
      slider.style.overflow = 'hidden';
      slider.scrollLeft = 0;
  
      // Determine interval (Shopify data-speed is seconds)
      const speedAttr = slider.getAttribute('data-speed');
      const seconds = speedAttr ? parseInt(speedAttr, 10) : 5;
      const intervalMs = (Number.isFinite(seconds) ? seconds : 5) * 1000;
  
      let index = 0;
      let timer = null;
  
      function setActive(i) {
        slides.forEach((el, idx) => {
          if (idx === i) el.classList.add('is-active');
          else el.classList.remove('is-active');
        });
      }
  
      function next() {
        index = (index + 1) % slides.length;
        setActive(index);
      }
  
      // Start with first slide active
      setActive(index);
  
      // Avoid multiple timers if re-init happens (theme editor, etc.)
      if (heroSlideshow.__unebiFadeTimer) {
        clearInterval(heroSlideshow.__unebiFadeTimer);
      }
  
      timer = setInterval(next, intervalMs);
      heroSlideshow.__unebiFadeTimer = timer;

      // If user switches tab, reduce weird jumps
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          if (heroSlideshow.__unebiFadeTimer) clearInterval(heroSlideshow.__unebiFadeTimer);
          heroSlideshow.__unebiFadeTimer = null;
        } else {
          if (!heroSlideshow.__unebiFadeTimer) {
            heroSlideshow.__unebiFadeTimer = setInterval(next, intervalMs);
          }
        }
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroFade);
    } else {
      initHeroFade();
    }
  
    // Shopify theme editor (optional safety)
    document.addEventListener('shopify:section:load', function (event) {
      // Re-init says: if hero section reloaded, restart
      initHeroFade();
    });
  })();
  